import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import './Navbar.css';
import Button from './Button';

const Navbar = () => {
    const { isAuthenticated, logout, userRole } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const normalizedRole = userRole ? userRole.trim() : "";
    const canReadInfo = ["Director", "Navegador", "Lector"].includes(normalizedRole);
    const canReadLinks = ["Director", "Navegador", "Lector"].includes(normalizedRole);
    const canReadQuestions = ["Director", "Navegador", "Lector"].includes(normalizedRole);
    const canManageChat = ["Director", "Navegador"].includes(normalizedRole);

    const isActive = (path) => location.pathname === path ? 'active' : '';
    const isActiveGroup = (paths) => paths.some(path => location.pathname.startsWith(path)) ? 'active' : '';

    return (
        <nav className="navbar">
            <h1>Viki</h1>
            <ul className="nav-list">
                <li><Link to="/" className={isActive('/')}>Inicio</Link></li>

                {isAuthenticated && (
                    <>
                        {/* Gestión de Usuarios */}
                        <li><Link to="/users" className={isActive('/users')}>Usuarios</Link></li>

                        {/* Dropdown: Información */}
                        {canReadInfo && (
                            <li className="dropdown">
                                <span className={`dropbtn ${isActiveGroup(['/tutorials', '/links', '/questions'])}`}>
                                    Información ▾
                                </span>
                                <div className="dropdown-content">
                                    <Link to="/tutorials">Tutoriales</Link>
                                    {canReadLinks && <Link to="/links">Links</Link>}
                                    {canReadQuestions && <Link to="/questions">Preguntas</Link>}
                                </div>
                            </li>
                        )}

                        {/* Dropdown: Comunicación */}
                        {canReadInfo && (
                            <li className="dropdown">
                                <span className={`dropbtn ${isActiveGroup(['/appointments', '/notifications'])}`}>
                                    Comunicación ▾
                                </span>
                                <div className="dropdown-content">
                                    <Link to="/appointments">Citas</Link>
                                    <Link to="/notifications">Notificaciones</Link>
                                </div>
                            </li>
                        )}

                        {/* Dropdown: Chat IA */}
                        {canManageChat && (
                            <li className="dropdown">
                                <span className={`dropbtn ${isActiveGroup(['/interviews', '/submissions', '/groups', '/test-chat', '/rag-docs'])}`}>
                                    Chat IA ▾
                                </span>
                                <div className="dropdown-content">
                                    <Link to="/interviews">Encuestas</Link>
                                    <Link to="/submissions">Respuestas</Link>
                                    <Link to="/test-chat">Chat de Prueba</Link>
                                    <Link to="/rag-docs">RAG Docs</Link>
                                </div>
                            </li>
                        )}
                    </>
                )}

                {isAuthenticated ? (
                    <li><Button className='button-logout' onClick={handleLogout}>Cerrar Sesión</Button></li>
                ) : (
                    <li><Link to="/login" className="button-login">Iniciar Sesión</Link></li>
                )}
            </ul>
        </nav>
    );
};

export default Navbar;
